import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export function Spinner({
  className,
  label,
  size = 'sm',
  ...props
}: ComponentProps<'span'> & { label?: string; size?: 'sm' | 'md' }) {
  return (
    <span
      {...props}
      role={label ? 'status' : undefined}
      aria-hidden={label ? undefined : true}
      className={cn('inline-flex items-center gap-2', className)}
    >
      <span
        className={cn(
          'inline-block shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent motion-reduce:animate-none',
          size === 'sm' ? 'size-4' : 'size-6',
        )}
      />
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  )
}
